export default __webpack_public_path__ + "static/media/folder_white.2cea449c.svg";